import { boot } from 'quasar/wrappers'
import { Loading } from 'quasar'

export default boot(({ router, store, redirect }) => {
  router.beforeEach((to, from, next) => {
    Loading.show()
    next()
  })

  router.afterEach(() => {
    Loading.hide()
  })
})
